$(function(){
    
    // when surgery modal is opened
    $('.SurgeryModal').on('show.bs.modal', function(){
        
        // get dynamic data from data attributes
        let virtualPagePath = $(this).data('virtual-page-path') || '';
        let virtualPageTitle = $(this).data('virtual-page-title') || '';

        // send GA
        dataLayer.push(
            { 
                'event': 'virtualPageview', 
                'virtualPagePath': virtualPagePath, 
                'virtualPageTitle': virtualPageTitle 
            }
        );

    });

});